import { DatePicker, Select } from "antd";
import { motion } from "framer-motion";
import styled from "styled-components";

export const Wrapper = styled.div<{ isOpen: boolean }>`
  height: 100%;
  width: 100%;
  width: ${(props) => (props.isOpen ? "calc(100% - 520px)" : "100%")};
  transition: width 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MotionWrapper = motion(Wrapper);

export const SSelect = styled(Select)`
  width: 100%;
  border-radius: 8px;
  color: white;
  box-sizing: border-box;
  height: 44.89px !important;

  .ant-select-selector {
    background-color: #333 !important;
    border: 1px solid #404040 !important;
    color: white !important;
    display: flex;
    align-items: center;
    box-sizing: border-box !important;
    padding: 0 1rem;
  }

  .ant-select-selection-item {
    color: white !important;
    font-size: 1rem;
  }

  .ant-select-arrow {
    color: rgb(255 255 255 / 25%) !important;
  }
`;

export const RightSidebar = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: ${(props) => (props.isOpen ? "0" : "-520px")};
  width: 520px;
  height: 100svh;
  background-color: transparent;
  transition: right 0.3s ease-in-out;
  box-sizing: border-box;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  background-color: #110f14;

  h3,
  p {
    color: #fff;
  }

  @media (max-width: 768px) {
    height: calc(100svh - 60px);
    width: 100vw;
    margin-top: 60px;
    right: ${(props) => (props.isOpen ? "0" : "-100vw")};
  }
`;

export const HeaderRightbar = styled.div`
  display: flex;
  flex-direction: row;
  height: 80px;
  padding: 0 20px;
  align-items: center;
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.1); */
  box-sizing: border-box;

  @media (max-width: 768px) {
    height: 60px;
    padding: 0rem 1rem;
  }
`;

export const PriceTag = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #fff;
  font-size: 0.875rem;

  .amount {
    font-weight: bold;
  }

  .period {
    color: #666;
  }
`;

// HOTEL INFORMATION POPUP
export const StyledInfoWindow = styled.div`
  width: 360px;
  display: flex;
  gap: 10px;

  @media (max-width: 520px) {
    flex-direction: column;
    width: fit-content;
  }
`;

export const Header = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
`;

export const HotelImage = styled.img`
  width: 120px;
  height: 80px;
  border-radius: 5px;
  object-fit: cover;

  @media (max-width: 520px) {
    width: 100%;
    height: 100px;
  }
`;

export const InfoColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 520px) {
    gap: 0.5rem;
  }
`;

export const DetailSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;

  & > *:first-child {
    align-items: center;
  }

  @media (max-width: 520px) {
    gap: 0.4rem;
  }
`;

export const InfoText = styled.p`
  margin: 0;
  display: flex;
  gap: 4px;

  p {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 0;
    margin: 0;
    min-height: 24px;
    b {
      margin-left: 5px;
    }
  }
`;

export const BookNow = styled.p`
  margin: 0;
  margin-left: 3px;
  cursor: pointer;
  color: #3a6df3;
  font-weight: 500;
  align-self: flex-end;
`;